import { jsx as _jsx } from "react/jsx-runtime";
import Checkbox from '@mui/material/Checkbox';
import TableCell from '@mui/material/TableCell';
import { defineStyles } from '../../theme';
import { cellStyle } from '../styles';
const styles = defineStyles({
    root: {
        ...cellStyle,
        textAlign: 'center',
        verticalAlign: 'middle',
    },
    checkbox: {
        paddingBlock: '0.125rem',
        paddingInline: 0,
    },
});
export function TableCheckbox({ checked, onClick }) {
    return (_jsx(TableCell, { onClick: onClick, width: 40, sx: {
            ...styles.root,
            position: 'sticky',
            left: 0,
            zIndex: 6,
            backgroundColor: 'inherit',
            borderBottom: '1px solid',
            borderBottomColor: 'divider',
            borderColor: 'divider',
        }, children: _jsx(Checkbox, { onChange: onClick, checked: checked, sx: styles.checkbox }) }));
}
//# sourceMappingURL=TableCheckbox.js.map